<script>
import lazyLoadComponent from '@router/lazyload-component'

export default {
  components: {
    CountryCodePicker: () => lazyLoadComponent(import('@components/CountryCodePicker')),
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    /**
     * @description 是否是商品開啟 true：預設開啟 / false：非商品開啟
     */
    isAutoOpen: {
      type: Boolean,
      default: false,
    },
    drawerOpenType: {
      type: Object,
      default: () => {
        return {
          autoOpenForGoodsAndMember: false, // 有會員&&自動開啟
          autoOpenForGoodsAndNonMember: false, // 無會員無訪客&&自動開啟
          autoOpenForGoodsAndVisit: false, // 訪客&&自動開啟
          normal: true, // 常態模式
        }
      },
    },
  },
  data() {
    return {
      activeSearchType: 'short',
      filterData: {
        search: '',
      },
      searchNone: false,
      tryingGetMember: false,
      searchData: {
        phoneCode: '+886',
        phoneNumber: '',
      },
      isNewMember: false,
    }
  },
  computed: {
    searchRules() {
      const isTaiwan = this.searchData.phoneCode === '+886'
      return {
        phoneNumber: [
          {
            pattern: isTaiwan ? /^09\d{8}$/ : '',
            message: '格式請符合 09XXXXXXXX',
            trigger: 'blur',
          },
        ],
      }
    },
    isString() {
      const result = parseInt(this.filterData.search)
      return !result
    },
  },
  created() {
    this.$store.commit('cart/CLEAR_CART')
  },
  methods: {
    // 快速搜尋
    async searchQuery(string, cb) {
      if (string && string.length >= 2) {
        let { items } = await this.$store.dispatch('member/fetchListShort', {
          paginate: 0,
          search: string,
        })
        if (items.length > 0) {
          items = items.map((item) => {
            return {
              ...item,
              value: item.phoneNumber,
            }
          })
          this.searchNone = false
          cb(items)
        } else {
          this.searchNone = true
          cb([{ value: '查無會員，立刻新增會員' }])
        }
      } else {
        cb([])
      }
    },
    /**
     * @description 選擇會員
     */
    async selectMember(item) {
      // 自動開啟form的新增會員
      if (this.isAutoOpen && this.drawerOpenType.autoOpenForGoodsAndNonMember && item.value && item.value === '查無會員，立刻新增會員') {
        this.filterData.search = ''
        this.searchData.phoneCode = '+886'
        this.searchData.phoneNumber = ''
        this.tryToSearchMemberByPhone()
        return
      }
      if (this.isAutoOpen && this.drawerOpenType.autoOpenForGoodsAndNonMember && item.value && item.value !== '查無會員，立刻新增會員') {
        this.$emit('showMemberInfo')
        this.updateMemberId(item.id)
        return
      }
      // 不是自動開啟，並且有查到會員，update之後就return
      if (item.value && item.value !== '查無會員，立刻新增會員' && !this.isAutoOpen && this.drawerOpenType.normal) {
        this.updateMemberId(item.id)
        return
      }
      // 不是自動開啟，沒有會員 => 新增會員
      if (item.value === '查無會員，立刻新增會員') {
        this.filterData.search = ''
        this.activeSearchType = 'phone' // 會切換tab
        this.$refs.autocomplete.$refs.suggestions.showPopper = false
        this.searchData.phoneCode = '+886'
        this.searchData.phoneNumber = ''
      }
    },
    searchQueryByBtn() {
      if (this.filterData.search) {
        this.$refs.autocomplete.$refs.suggestions.showPopper = true
      }
    },
    memberPets(item) {
      if (item.value !== '查無會員，立刻新增會員') {
        const petNames = item.pets.map((pet) => pet.name)
        return petNames.join('，')
      }

      return ''
    },
    getSinglePetName(item) {
      const petNames = item.pets.map((pet) => pet.name.toLowerCase())
      const index = petNames.findIndex((name) => name.includes(this.filterData.search.toLowerCase()))

      return index !== -1 ? item.pets[index].name : ''
    },
    /**
     * @description 藉由手機號碼找出Member
     */
    async tryToSearchMemberByPhone() {
      if (this.$refs.searchFormByPhone) {
        await this.$refs.searchFormByPhone.validate()
      }
      this.tryToSearchMember()
    },
    /**
     * @description searchMember API
     */
    async tryToSearchMember() {
      this.tryingGetMember = true
      try {
        const member = await this.$store.dispatch('member/findByPhone', this.searchData)
        this.updateMemberId(member.id)
        this.isNewMember = false
      } catch {
        this.createMember()
        this.isNewMember = true
      } finally {
        this.tryingGetMember = false
      }
    },
    updateMemberId(id) {
      this.$emit('update', id)
    },
    /***
     * @description 新增會員
     */
    createMember() {
      this.$emit('create', this.searchData)
    },
  },
}
</script>
<template>
  <div :class="{ [$style.orderformSection]: true, [$style.isAutoOpenStyle]: isAutoOpen && drawerOpenType.autoOpenForGoodsAndNonMember }">
    <div class="search-section">
      <el-tabs v-model="activeSearchType" stretch>
        <el-tab-pane name="short" class="mobile-space">
          <div v-if="!isAutoOpen && drawerOpenType.normal" slot="label" class="tabHeader">快速搜尋</div>
          <div class="search-box__wrapper">
            <el-form ref="searchFormByShort" class="el-form-item--normal-margin el-form-item--white-bg search-box" :model="filterData" @submit.native.prevent>
              <el-form-item>
                <span slot="label"
                  >快速查詢客戶 <span class="text-muted-0">（請輸入電話號碼或{{ $t('reserve.CLIENT') }}名稱）</span></span
                >
                <el-autocomplete ref="autocomplete" v-model="filterData.search" style="width: 100%" :fetch-suggestions="searchQuery" @select="selectMember">
                  <template v-slot="{ item }">
                    <span class="info-line-box">
                      <span v-if="searchNone" class="add-box"> 查無會員，立刻新增會員 <BaseIcon name="plus"></BaseIcon> </span>
                      <template v-else-if="!isString">
                        <span class="info-line content">{{ item.phoneNumber }}</span>
                        <span class="info-line title">{{ item.fullName }}</span>
                        <span class="info-line more-content">{{ memberPets(item) }}</span>
                      </template>
                      <template v-else>
                        <span class="info-line content">{{ getSinglePetName(item) }}</span>
                        <span class="info-line title">{{ item.fullName }}</span>
                        <span class="info-line more-content">{{ item.phoneNumber }}</span>
                      </template>
                    </span>
                  </template>
                </el-autocomplete>
              </el-form-item>
              <el-button class="is-round is-fullwidth" :loading="tryingGetMember || loading" @click="searchQueryByBtn">查詢</el-button>
              <el-divider v-if="isAutoOpen && drawerOpenType.autoOpenForGoodsAndNonMember"></el-divider>
              <el-button v-if="isAutoOpen && drawerOpenType.autoOpenForGoodsAndNonMember" class="is-round is-fullwidth" :loading="tryingGetMember || loading" @click="tryToSearchMemberByPhone"
                >新增客戶</el-button
              >
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane v-if="!isAutoOpen && drawerOpenType.normal" label="新增電話" name="phone">
          <div class="search-box__wrapper">
            <el-form ref="searchFormByPhone" class="el-form-item--normal-margin el-form-item--white-bg search-box" :model="searchData" :rules="searchRules">
              <el-form-item prop="phoneNumber">
                <span slot="label">新增客戶 </span>
                <el-input v-model.trim="searchData.phoneNumber" placeholder="請輸入手機號碼" @keyup.native.enter="tryToSearchMemberByPhone">
                  <CountryCodePicker slot="prepend" v-model="searchData.phoneCode" />
                </el-input>
              </el-form-item>
              <el-button class="is-round is-fullwidth isPrimaryOutLine" :loading="tryingGetMember || loading" @click="tryToSearchMemberByPhone">新增</el-button>
              <span v-if="isNewMember" class="alert-word" style="margin-top: 20px; display: block">查無客戶資訊，快速建立客戶</span>
            </el-form>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<style lang="scss" module>
@import '@design';

.orderformSection {
  :global {
    .search-box {
      min-width: 400px;

      @include max-md {
        min-width: 300px;
      }

      @include max-lg {
        min-width: 300px;
      }

      @include touch {
        width: 100%;
        min-width: 0;
      }

      margin-top: 60px;

      &__wrapper {
        display: flex;
        // align-items: center;
        justify-content: center;
        // height: calc(100vh - 348px);
      }
    }

    .search-section {
      height: 100%;
    }
  }
}

.isAutoOpenStyle {
  :global {
    .el-tabs__header {
      display: none !important;
    }

    .search-box {
      min-width: 600px !important;
    }
  }
}
</style>
